import gsap from 'gsap'

export const animateQuestionMarkPopIn = (
  target: SVGGElement | null
): gsap.core.Tween | undefined => {
  if (!target) return undefined

  return gsap.fromTo(
    target,
    { scale: 0, opacity: 0 },
    {
      scale: 1,
      opacity: 1,
      duration: 0.75,
      delay: 0.2,
      ease: 'back.out(2)',
      transformOrigin: 'center',
    }
  )
}

export const animateAccountCards = (
  container: HTMLElement | null
): gsap.core.Tween | undefined => {
  if (!container?.children.length) return undefined

  return gsap.fromTo(
    container.children,
    { opacity: 0, y: 12 },
    { opacity: 1, y: 0, duration: 0.4, stagger: 0.1, ease: 'power2.out' }
  )
}
